export const playAudioFromBase64 = (base64) => {
  const prefix = "data:audio/wav;base64,";
  const audio = new Audio(prefix + base64);
  audio.play();
};
